<template>
  <v-navigation-drawer
    app
    clipped-left
    :mini-variant="isSmall"
    mini-variant-width="72"
    permanent
  >
    <v-list-item
      v-if="isMiniVariant && !$vuetify.breakpoint.mdAndDown"
    >
      <v-list-item-content>
        <v-btn
          fab
          small
          text
          @click="isMiniVariant = false"
        >
          <v-icon>
            arrow_forward
          </v-icon>
        </v-btn>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <div
            v-if="isSmall"
            class="text-center"
          >
            <v-icon>
              favorite
            </v-icon>
          </div>
          <div
            v-else
            class="caption font-weight-bold text-uppercase"
          >
            {{ $t('servers_liked') }}
          </div>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          fab
          small
          text
          @click="isMiniVariant = true"
        >
          <v-icon
            small
          >
            arrow_back
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <template
      v-if="$isLoggedIn"
    >
      <template
        v-if="items && items.all().length > 0"
      >
        <v-list-item
          v-for="(item) in items"
          :key="item.data.id"
          :to="{ name: 'server.show', params: { serverId: item.data.id} }"
        >
          <v-list-item-avatar
            class="elevation-1"
          >
            <img
              :src="`${config.IMAGE_SERVICE_URL}/servers/${item.data.id}/icon.png`"
            >
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle
              class="font-weight-bold"
            >
              {{ item.data.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-avatar
                class="mr-1"
                :color="item.data.is_online ? 'green' : 'red'"
                size="8"
              />
              <span
                v-if="item.data.is_online"
              >
                {{ $tc('players_online', item.data.player_count) }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-item
        v-else-if="!isSmall"
      >
        <v-list-item-content
          class="body-2"
        >
          {{ $t('servers_not_liked_yet') }}
        </v-list-item-content>
      </v-list-item>
    </template>
    <template
      v-else-if="!isSmall"
    >
      <v-list-item>
        <v-list-item-content
          class="py-0"
        >
          <v-card
            color="secondary"
            :to="{ name: 'user.create' }"
          >
            <v-card-text
              class="font-weight-regular subtitle-1 white--text"
            >
              {{ $t('sign_up_to_follow_servers') }}
            </v-card-text>
          </v-card>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:append>
      <div class="text-center">
        <div
          v-if="!isSmall"
          class="pb-2"
        >
          <LanguagePicker />
        </div>
        <div
          class="pb-2"
        >
          <v-btn
            v-for="(item, index) in socialMedia"
            :key="index"
            fab
            :href="item.url"
            small
            target="_blank"
            text
          >
            <v-icon
              small
            >
              {{ item.icon }}
            </v-icon>
          </v-btn>
        </div>
        <div
          v-if="!isSmall"
          class="caption pb-2"
        >
          © 2007-{{ (new Date()).getFullYear() }}. {{ $t('all_rights_reserved') }}
        </div>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { Server } from '@serversgg/sdk-js'

import LanguagePicker from '@/components/LanguagePicker'

export default {
  name: 'AppNavigation',

  components: {
    LanguagePicker,
  },

  data () {
    return {
      config: {
        IMAGE_SERVICE_URL: process.env.IMAGE_SERVICE_URL || 'https://img.servers.gg',
      },
      isMiniVariant: false,
      items: null,
      socialMedia: [
        {
          icon: 'fab fa-twitch',
          url: 'https://twitch.tv/ServersGG',
        },
        {
          icon: 'fab fa-twitter',
          url: 'https://twitter.com/ServersGG',
        },
        {
          icon: 'fab fa-youtube',
          url: 'https://www.youtube.com/channel/UCgwj3k1nHD1MdRa99_-tY2w',
        },
      ],
    }
  },

  computed: {
    isSmall () {
      return this.isMiniVariant || this.$vuetify.breakpoint.smAndDown
    },
  },

  watch: {
    async '$store.state.likedServers.items' () {
      await this.loadItems()
    },
  },

  async created () {
    await this.loadItems()
  },

  methods: {
    async loadItems () {
      const likes = this.$store.state.likedServers.items

      if (likes.length <= 0) {
        this.items = null
        return
      }

      this.items = await Server.request()
        .setInclude('game')
        .fetch({
          id: likes.map(like => like.data.server_id).join(','),
          sort_by: 'player_count',
          sort_order: 'desc',
        })
    },
  },
}
</script>
